// config.js is created by the build script from the runtim environment variables and is loaded in public/index.html
// There is no other way to inject environment variables straight before run-time in an application seved by nginx or apache

export const authStrategy ='local'
export const {otherApis,api,baseUrl,loginApi, devMode} = window['runtimeConfig']
export const wsBase=devMode ? 'sign.dev.apis2.paeckli24.de' : 'sign.apis2.paeckli24.de'
